module.exports = __webpack_public_path__ + "static/media/img-t2.fd009837.png";